import React from 'react';
import { MessageCircle, Zap, TrendingUp, Scale } from 'lucide-react';

const CadenceFeatures = () => {
  const features = [
    {
      icon: MessageCircle,
      title: 'Realistic AI Role-Play',
      tagline: 'Navigator AI simulates the conversations your teams actually have.',
      bullets: [
        'Customer, client, and internal scenarios',
        'Objection handling and difficult conversations',
        'Tone, clarity, and confidence alignment',
        'Industry- and role-specific practice'
      ],
      bottomLine: 'Practice feels real — because it is.'
    },
    {
      icon: Zap,
      title: 'Real-Time Scoring & Feedback',
      tagline: 'Cadence doesn\'t just simulate conversations — it evaluates them.',
      bullets: [
        'Immediate, objective feedback',
        'Consistent scoring across every team member',
        'Clear strengths and improvement areas',
        'No bias. No guesswork.'
      ],
      bottomLine: 'Teams improve while they practice.'
    },
    {
      icon: TrendingUp,
      title: 'Skill Progression & Visibility',
      tagline: 'Leaders get insight without micromanagement.',
      bullets: [
        'Track skill development over time',
        'Identify coaching opportunities early',
        'Compare performance across roles, teams, and locations',
        'Connect Traaining to outcomes'
      ],
      bottomLine: 'Cadence turns practice into actionable intelligence.'
    },
    {
      icon: Scale,
      title: 'Practice at Enterprise Scale',
      tagline: 'Cadence is designed for modern, distributed organizations.',
      bullets: [
        'No scheduling bottlenecks',
        'No manager dependency',
        'No inconsistent coaching',
        'Unlimited practice without added overhead'
      ],
      bottomLine: 'Teams practice daily. Performance compounds monthly.'
    }
  ];

  return (
    <section className="py-20 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 text-white">
            What Traain Cadence <span className="text-cyan-400">Delivers</span>
          </h2>
        </div>

        <div className="space-y-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="p-8 bg-gradient-to-br from-gray-800/50 to-gray-900/50 border border-gray-700/50 rounded-2xl hover:border-cyan-500/50 transition-all duration-300"
            >
              <div className="flex items-start gap-6 mb-6">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan-500/20 to-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-7 h-7 text-cyan-400" />
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-white mb-2">{feature.title}</h3>
                  <p className="text-gray-400">{feature.tagline}</p>
                </div>
              </div>
              
              <div className="grid md:grid-cols-2 gap-3 mb-6 ml-20">
                {feature.bullets.map((bullet, bulletIndex) => (
                  <div key={bulletIndex} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                    <span className="text-gray-300">{bullet}</span>
                  </div>
                ))}
              </div>
              
              <div className="ml-20">
                <p className="text-cyan-400 font-semibold italic">{feature.bottomLine}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CadenceFeatures;
